import { TFunction } from "i18next";

import {
	getOrderPassengerPoints,
	stringifyPoint,
} from "../../../../../../../redux/constants/OrdersPage/order";

import type { Order } from "../../../../../../../services";

const cellProcessing = (item?: Order.Model, t?: TFunction) => {
	if (!item || !t) return { content: "" };

	const points = getOrderPassengerPoints(item) ?? [];
	const pointOnMap = t(["point_on_map"]);

	const content = points?.[0]
		? stringifyPoint(points[0], "address", pointOnMap)
		: "";

	const backgroundColor =
		item?.highlighting?.type === "address"
			? item?.highlighting?.color ?? ""
			: undefined;

	return { content, backgroundColor };
};

export default cellProcessing;
